var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 87,
    viewBox: "0 0 97 87",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9776_12609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.6995 24.1172V79.1099C96.6995 83.2381 93.3017 86.585 89.1108 86.585H7.54333C3.36419 86.585 -0.0234375 83.2481 -0.0234375 79.1315V4.58042C-0.0234375 3.70747 0.694789 3 1.58102 3H15.5837H29.5863C30.4725 3 31.1908 3.70747 31.1908 4.58042V7.56669H83.7494C84.6357 7.56669 85.3539 8.27416 85.3539 9.14712V22.5368H95.0945C95.9813 22.5368 96.6995 23.2448 96.6995 24.1172Z",
    fill: "#2A303B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5435 85.6261C3.90726 85.6261 0.949219 82.7124 0.949219 79.1307V4.57954C0.949219 4.23635 1.23279 3.95703 1.58119 3.95703C12.5179 3.95703 18.6497 3.95703 29.5865 3.95703C29.9349 3.95703 30.2184 4.23635 30.2184 4.57954V8.52373H83.7496C84.098 8.52373 84.3816 8.80305 84.3816 9.14623V23.4939H95.0941C95.4425 23.4939 95.7261 23.7732 95.7261 24.1164V79.109C95.7261 82.7024 92.7579 85.6261 89.1098 85.6261H7.5435Z",
    fill: "#2A303B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9521 83.6688H7.17271C5.82195 83.6688 4.72656 82.5898 4.72656 81.2593V13.8359H88.9521V83.6688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.747 15.4863H6.52148V83.7887H90.747V15.4863Z",
    fill: "#EBEDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6025 17.8984H8.37695V83.6691H92.6025V17.8984Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6338 20.4316H10.4082V83.6701H94.6338V20.4316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7324 24.1507V79.0795C96.7324 83.2077 93.3347 86.5546 89.1437 86.5546H11.938L11.8151 86.5862H7.5441C7.21712 86.5862 6.89578 86.5657 6.58008 86.5263L11.938 83.341V24.2351C11.938 23.3155 12.6946 22.5703 13.6282 22.5703H95.128C96.0142 22.5703 96.7324 23.2778 96.7324 24.1507Z",
    fill: "#18202E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0838 47.3539L58.0838 47.353L58.0833 47.3153C58.0833 47.3151 58.0833 47.315 58.0833 47.3149C58.0761 46.5795 57.7743 45.971 57.2073 45.5566C56.6495 45.149 55.8585 44.9457 54.8922 44.955C53.0512 44.9724 51.0614 45.8936 49.2716 47.461L45.6303 42.7468C47.9262 40.4733 51.036 38.8364 55.3415 38.7962C58.1582 38.77 60.5367 39.5144 62.2117 40.8644C63.8815 42.2104 64.8707 44.1724 64.8938 46.6299L64.8938 46.6308L64.8948 46.7072C64.8948 46.7073 64.8948 46.7075 64.8948 46.7076C64.9172 49.096 64.1401 50.7862 62.8493 52.0164C61.5491 53.2556 59.7076 54.0472 57.5712 54.5879L57.4148 54.6275L57.3865 54.7864L56.9787 57.0767L52.6934 57.1169L51.7109 50.9558L51.8768 50.7659C54.0867 50.5481 55.622 50.1732 56.612 49.6261C57.118 49.3464 57.4912 49.0166 57.7359 48.6308C57.9818 48.2431 58.0882 47.8142 58.0838 47.3539ZM51.2136 66.0035L51.1566 59.8882L58.3223 59.8215L58.3794 65.9369L51.2136 66.0035Z",
    fill: "black",
    fillOpacity: 0.05,
    stroke: "#EDFF6B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M96.7344 76.0156V79.0771C96.7344 79.6718 96.6639 80.2499 96.5303 80.8052C96.214 82.1246 95.5426 83.3085 94.6197 84.2537C93.2391 85.6708 91.2969 86.5527 89.1456 86.5527H11.94L11.8171 86.5843H7.54606C7.21908 86.5843 6.89774 86.5638 6.58203 86.5244L10.4015 84.2537L11.94 83.3391V76.0156H96.7344Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M96.5303 80.8047C96.214 82.1241 95.5426 83.308 94.6197 84.2532C93.2391 85.6703 91.2969 86.5522 89.1456 86.5522H11.94L11.8171 86.5838H7.54606C7.21908 86.5838 6.89774 86.5633 6.58203 86.5239L10.4015 84.2532L11.94 83.3386V80.8047H96.5303Z",
    fill: "#2A303B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M94.6197 84.2539C93.2391 85.6711 91.2969 86.5529 89.1456 86.5529H11.94L11.8171 86.5846H7.54606C7.21908 86.5846 6.89774 86.564 6.58203 86.5246L10.4015 84.2539H94.6197Z",
    fill: "#2A303B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56155 85.6261C3.91572 85.6261 0.949219 82.7041 0.949219 79.1129V4.57954C0.949219 4.23635 1.23279 3.95703 1.58119 3.95703H1.77569C2.12409 3.95703 2.40766 4.23635 2.40766 4.57954V79.2095C2.40766 82.0594 4.73204 84.4078 7.58917 84.4444C7.61229 84.445 7.63596 84.445 7.65851 84.445C10.554 84.445 12.9094 82.1249 12.9094 79.2728V24.1486C12.9094 23.8054 13.1929 23.5261 13.5413 23.5261C13.8897 23.5261 14.1733 23.8054 14.1733 24.1486V79.0318C14.1733 82.6558 11.2175 85.6139 7.5841 85.6261H7.56155Z",
    fill: "#EDFF6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9776_12609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 87,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.388e042b304bb4e22c4c11ba70e69bb3.svg";
export { ForwardRef as ReactComponent };